<template>
  <div :class="$style.container">
    <message-preview
      v-for="message in messages"
      :key="message.id"
      :message="message"
      :class="$style.messagesContainer" />
  </div>
</template>

<script>
  import axios from 'axios'
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'
  import MessagePreview from './message-preview/message-preview'

  export default {
    components: {
      MessagePreview
    },
    data () {
      return {
        messages: [],
        team: store.get('team')
      }
    },
    computed: {
      hasDialpad () {
        return this.team.features.find(feature => feature.name === 'DIALER_DIALPAD')
      }
    },
    mounted () {
      this.getMessages()
    },
    methods: {
      async getMessages () {
        try {
          const response = await axios.get(`${jiminnyHost()}/api/v1/sms`)
          let messages = response.data

          if (!this.hasDialpad) {
            messages = messages.filter(({prospect}) => {
              return prospect.prospectId !== null && prospect.prospectType !== null
            })
          }

          this.messages = messages
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
</script>

<style module lang="less" src="./messages-list.less"></style>



// WEBPACK FOOTER //
// messages-list.vue?375198ec